import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import KidsTakeoverForm from "./forms/KidsTakeoverForm";

[].forEach.call(
    document.querySelectorAll('.KidsTakeoverForm'),
    (target) => {
        ReactDOM.render(
            <KidsTakeoverForm elementId={target.dataset.id} />,
            target
        );
    }
);
